<script>
  import { onMount } from "svelte";
  /* Executable code section of the program */
  //Tools importation
  import { meetingInfo, isAttendeeMeetModalOn } from "../../apis/storage";

  //Auxiliary variables
  // Definition of the window witdh
  let windowSize = window.innerWidth;
  let allAttendees = [];

  //function to undisplay modal
  const undisplayModal = () => {
    $isAttendeeMeetModalOn = false;
  };

  onMount(() => {
    allAttendees = [
      ...($meetingInfo.acceptedAttendees || []),
      ...($meetingInfo.declinedAttendees || []),
      ...($meetingInfo.invitedAttendees || []),
    ];
    console.log(allAttendees);
    
  });

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="principalContainer">
  <div class="contentContainer">
    <div class="headerContainer">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        fill="currentColor"
        class="bi bi-x-lg icon"
        viewBox="0 0 16 16"
        on:click={undisplayModal}
        on:keypress={undisplayModal}
      >
        <path
          d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"
        />
      </svg>
    </div>
    <div class="bodyContainer">
      <div class="headerContent">
        <h3>Invited Attendees</h3>
      </div>
      <div class="bodyContent">
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Attendee</th>
              {#if windowSize > 1100}
                <th scope="col">Country</th>
              {:else if windowSize > 700 && windowSize <= 1100}
                <th scope="col">Country</th>
              {/if}
              <th scope="col">Jobtittle</th>
              <th scope="col">Company</th>
            </tr>
          </thead>
          <tbody>
            {#each allAttendees as attendee, index}
              <tr>
                <th scope="row">{index + 1}</th>
                <td>
                  {attendee.name || attendee.attendeeName}
                  {attendee.surname || attendee.attendeeSurname}
                </td>
                {#if windowSize > 1100}
                  <td>{attendee.country || attendee.attendeeCountry}</td>
                {:else if windowSize > 700 && windowSize <= 1100}
                  <td>{attendee.country || attendee.attendeeCountry}</td>
                {/if}                
                <td>{attendee.jobtittle || attendee.attendeeJobittle}</td>
                <td>{attendee.company || attendee.attendeeCompany}</td>
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal styles */
  .principalContainer {
    position: fixed;
    top: 0;
    z-index: 888;
    width: 100%;
    height: 100dvh;
    background-color: rgba(0, 0, 0, 0.247);
    display: flex;
    justify-content: center;
    padding: 30px;
  }
  /* Content styles */
  .contentContainer {
    overflow: auto;
    width: 50%;
    height: auto;
    max-height: 70vh;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }
  /* HeaderContent styles */
  .headerContainer {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 20px;
  }
  .icon:hover {
    cursor: pointer;
    color: red;
  }
  /* Body Content */
  /* header */
  .bodyContainer {
    width: 100%;
  }
  .headerContent {
    width: 100%;
    border-bottom: 1px solid gray;
    padding: 15px;
  }
  /* Body */
  .bodyContent {
    width: 100%;
    padding: 10px;
    display: flex;
    margin: 10px 0;
  }
  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    /* Content styles */
    .contentContainer {
      overflow: auto;
      width: 80%;
      height: auto;
      max-height: 40vh;
      background-color: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    /* Principal container styles */
    .principalContainer {
      padding: 5px;
    }
    /* Content styles */
    .contentContainer {
      overflow: auto;
      width: 100%;
      height: auto;
      max-height: 90vh;
      background-color: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 10px;
    }
    /* Body */
  }
  /* End of the section */
</style>
